import React from 'react';

function PDFViewer(props) {
    const {pdfUrl} = props;
  return (
    <>

    <div>
    
     <iframe
          src={pdfUrl}
          // src={pdfUrl + "#toolbar=0&navpanes=0&scrollbar=0"}
          title="title"
        ></iframe>
       

        {/* <object data={pdfUrl} type="application/pdf" target="_blank"  width="100%" height="500">
          <p>Your browser does not support PDFs. <a target="_blank"  href={pdfUrl}>Download the PDF</a> instead.</p>
      </object> */}

      
    </div>
    <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
       View File
      </a>
    </>

  );
}

export default PDFViewer;



// import React from 'react';
// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';

// function PDFViewer(props) {
//   const { pdfUrl } = props;
//   return (

//     <div style={{ width: '100%' }}>
//       <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.2.228/build/pdf.worker.min.js">
//         <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
//           <Viewer fileUrl={pdfUrl} pageNumber={1} /> {/* Set pageNumber to 1 */}
//         </a>
//       </Worker>
//     </div>

//   );
// }

// export default PDFViewer;
